<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Modal</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <!-- Modal: How it works -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">How it works</h5>
              <p>Before getting started with Bootstrap’s modal component, be sure to read the following as our menu
                options have recently changed.</p>
              <ul>
                <li>Modals are built with HTML, CSS, and JavaScript. They’re positioned over everything else in the
                  document and remove scroll from the <code class="text-danger">&lt;body&gt;</code> so that modal
                  content
                  scrolls instead.</li>
                <li>Clicking on the modal “backdrop” will automatically close the modal.</li>
                <li>Bootstrap only supports one modal window at a time. Nested modals aren’t supported as we believe
                  them
                  to be poor user experiences.</li>
                <li>Modals use <code class="text-danger">position: fixed</code>, which can sometimes be a bit particular
                  about its rendering. Whenever possible, place your modal HTML in a top-level position to avoid
                  potential
                  interference from other elements. You’ll likely run into issues when nesting a <code
                    class="text-danger">.modal</code> within another fixed element.</li>
                <li>Once again, due to <code class="text-danger">position: fixed</code>, there are some caveats with
                  using
                  modals on mobile devices. <a
                    href="https://getbootstrap.com/docs/4.5/getting-started/browsers-devices/#modals-and-dropdowns-on-mobile">See
                    our browser support docs</a> for details.</li>
                <li>Due to how HTML5 defines its semantics, <a
                    href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-autofocus">the <code
                      class="text-danger">autofocus</code> HTML attribute</a> has no effect in Bootstrap modals. To
                  achieve the same effect, use some custom JavaScript:</li>
              </ul>
              <div class="card mb-5 shadow-sm">
                <div class="card-footer">
                  <!-- $('#myModal').on('shown.bs.modal', function () {
                  $('#myInput').trigger('focus')
                  }) -->
                </div>
              </div>
            </div>

            <!-- Modal: Example -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Modal components</h5>
              <p>Below is a <em>static</em> modal example (meaning its <code class="text-danger">position</code> and
                <code class="text-danger">display</code> have been overridden). Included are the modal header, modal
                body
                (required for <code class="text-danger">padding</code>), and modal footer (optional). We ask that you
                include modal headers with dismiss actions whenever possible, or provide another explicit dismiss
                action.
              </p>
              <button type="button" class="btn btn-primary" (click)="openModal(template)">Launch
                demo modal</button>
              <div class="card mb-5 shadow-sm mt-3">
                <div class="card-body">
                  <div class="modal" tabindex="-1"
                    style="position: relative; top: auto; right: auto;bottom: auto; left: auto; z-index: 1; display: block;">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title">Modal title</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <p>Modal body text goes here.</p>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                          <button type="button" class="btn btn-primary">Save changes</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Modal -->
                  <ng-template #template>
                    <div class="modal-header">
                      <h5 class="modal-title pull-left" id="exampleModalLabel"
                        style="font-family: 'IBM Plex Sans', sans-serif;">Modal title</h5>
                      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body" style="font-family: 'IBM Plex Sans', sans-serif;">
                      Woohoo, you're reading this text in a modal!
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" (click)="modalRef.hide()"
                        style="background-color: #00028C;font-family: 'IBM Plex Sans', sans-serif;">Close</button>
                      <button type="button" class="btn btn-primary"
                        style="background-color: #21AA93;font-family: 'IBM Plex Sans', sans-serif;">Save
                        changes</button>
                    </div>
                  </ng-template>

                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;modal&quot; tabindex=&quot;-1&quot;&gt;
    &lt;div class=&quot;modal-dialog&quot;&gt;
      &lt;div class=&quot;modal-content&quot;&gt;
        &lt;div class=&quot;modal-header&quot;&gt;
          &lt;h5 class=&quot;modal-title&quot;&gt;Modal title&lt;/h5&gt;
          &lt;button type=&quot;button&quot; class=&quot;close&quot; data-dismiss=&quot;modal&quot; aria-label=&quot;Close&quot;&gt;
            &lt;span aria-hidden=&quot;true&quot;&gt;&amp;times;&lt;/span&gt;
          &lt;/button&gt;
        &lt;/div&gt;
        &lt;div class=&quot;modal-body&quot;&gt;
          &lt;p&gt;Modal body text goes here.&lt;/p&gt;
        &lt;/div&gt;
        &lt;div class=&quot;modal-footer&quot;&gt;
          &lt;button type=&quot;button&quot; class=&quot;btn btn-secondary&quot; data-dismiss=&quot;modal&quot;&gt;Close&lt;/button&gt;
          &lt;button type=&quot;button&quot; class=&quot;btn btn-primary&quot;&gt;Save changes&lt;/button&gt;
        &lt;/div&gt;
      &lt;/div&gt;
    &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
